export const ALLERGENS = {
  gluten: { en: 'Gluten', ja: '小麦' },
  soy: { en: 'Soy', ja: '大豆' },
  egg: { en: 'Egg', ja: '卵' },
  fish: { en: 'Fish', ja: '魚' },
  shellfish: { en: 'Shellfish', ja: '甲殻類' },
  sesame: { en: 'Sesame', ja: 'ごま' },
  dairy: { en: 'Dairy', ja: '乳' },
  peanut: { en: 'Peanut', ja: '落花生' },
  treeNut: { en: 'Tree nuts', ja: '木の実' }
};

export const recipes = [
  {
    id: 'chicken-rice', emoji: '🍗', color: 'turmeric', servings: 4, prepMinutes: 20, cookMinutes: 35,
    title: { en: 'One-pot Hainanese Chicken Rice', ja: '炊飯器で海南チキンライス' },
    summary: { en: 'Tender ginger chicken and fragrant rice with cucumber.', ja: '生姜香るやわらか鶏とご飯。きゅうりを添えて。' },
    tags: ['family', 'one-pot', 'freezer'], allergens: ['soy', 'sesame'],
    ingredients: [
      { id: 'chicken-thigh', qty: 600, unit: 'g', name: { en: 'boneless chicken thighs', ja: '鶏もも肉' }, category: 'protein' },
      { id: 'rice', qty: 2, unit: 'cup', name: { en: 'jasmine rice', ja: 'ジャスミン米' }, category: 'pantry' },
      { id: 'ginger', qty: 25, unit: 'g', name: { en: 'ginger, sliced', ja: '生姜（薄切り）' }, category: 'produce' },
      { id: 'garlic', qty: 3, unit: 'clove', name: { en: 'garlic', ja: 'にんにく' }, category: 'produce' },
      { id: 'chicken-stock', qty: 500, unit: 'ml', name: { en: 'low-sodium chicken stock', ja: '減塩チキンスープ' }, category: 'pantry' },
      { id: 'cucumber', qty: 1, unit: 'pc', name: { en: 'cucumber', ja: 'きゅうり' }, category: 'produce' },
      { id: 'light-soy', qty: 2, unit: 'tbsp', name: { en: 'light soy sauce', ja: '薄口醤油' }, category: 'pantry' },
      { id: 'sesame-oil', qty: 1, unit: 'tsp', name: { en: 'sesame oil', ja: 'ごま油' }, category: 'pantry' },
      { id: 'chilli-powder', qty: 1, unit: 'tsp', name: { en: 'chilli powder', ja: '粉唐辛子' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Rinse rice until water is nearly clear; drain well.', ja: '米を水がほぼ透明になるまで洗い、しっかり水を切る。' },
      { en: 'Rub chicken with soy sauce and sesame oil. Rest 10 minutes.', ja: '鶏肉に醤油とごま油を揉み込み、10分置く。' },
      { en: 'Put rice, stock, ginger and garlic in a rice cooker. Lay chicken on top and cook normally.', ja: '炊飯器に米、スープ、生姜、にんにくを入れ、鶏肉をのせて通常炊飯する。' },
      { en: 'Check chicken reaches 75°C, rest 5 minutes, slice and serve with cucumber.', ja: '鶏肉の中心温度が75℃に達したら5分休ませ、切ってきゅうりと盛る。' }
    ],
    safety: { en: 'Cook poultry to 75°C. Cool leftovers within 2 hours and refrigerate up to 3 days.', ja: '鶏肉は中心75℃まで加熱。残りは2時間以内に冷まし、冷蔵3日以内。' }
  },
  {
    id: 'miso-salmon', emoji: '🐟', color: 'coral', servings: 4, prepMinutes: 15, cookMinutes: 18,
    title: { en: 'Miso Salmon & Sesame Greens', ja: '鮭の味噌焼きとごま青菜' },
    summary: { en: 'Caramelised miso salmon with crisp green vegetables.', ja: '香ばしい味噌鮭とシャキッとした青菜。' },
    tags: ['quick', 'high-protein'], allergens: ['fish', 'soy', 'sesame'],
    ingredients: [
      { id: 'salmon', qty: 600, unit: 'g', name: { en: 'salmon fillets', ja: '鮭切り身' }, category: 'protein' },
      { id: 'white-miso', qty: 2, unit: 'tbsp', name: { en: 'white miso', ja: '白味噌' }, category: 'pantry' },
      { id: 'mirin', qty: 1, unit: 'tbsp', name: { en: 'mirin', ja: 'みりん' }, category: 'pantry' },
      { id: 'light-soy', qty: 1, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'bok-choy', qty: 500, unit: 'g', name: { en: 'baby bok choy', ja: '青梗菜' }, category: 'produce' },
      { id: 'sesame-seed', qty: 1, unit: 'tbsp', name: { en: 'sesame seeds', ja: '白ごま' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Mix miso, mirin and soy; coat salmon and rest 10 minutes.', ja: '味噌、みりん、醤油を混ぜ、鮭に塗って10分置く。' },
      { en: 'Bake at 210°C for 12–15 minutes until the centre reaches 63°C.', ja: '210℃で12〜15分、中心温度63℃まで焼く。' },
      { en: 'Steam bok choy for 3–4 minutes and scatter with sesame.', ja: '青梗菜を3〜4分蒸し、ごまを振る。' },
      { en: 'Serve immediately, or cool quickly before packing.', ja: 'すぐに盛るか、弁当用なら素早く冷ます。' }
    ],
    safety: { en: 'Fish should reach 63°C and flake easily. Check miso and soy labels for gluten.', ja: '魚は中心63℃、身がほぐれるまで加熱。味噌・醤油の小麦表示を確認。' }
  },
  {
    id: 'tofu-laksa', emoji: '🥥', color: 'chilli', servings: 4, prepMinutes: 20, cookMinutes: 25,
    title: { en: 'Weeknight Tofu Laksa', ja: '平日の豆腐ラクサ' },
    summary: { en: 'A lighter coconut noodle soup packed with tofu and vegetables.', ja: '豆腐と野菜たっぷり、軽めのココナッツ麺スープ。' },
    tags: ['vegetarian', 'one-pot'], allergens: ['soy', 'gluten'],
    ingredients: [
      { id: 'firm-tofu', qty: 400, unit: 'g', name: { en: 'firm tofu', ja: '木綿豆腐' }, category: 'protein' },
      { id: 'rice-noodle', qty: 300, unit: 'g', name: { en: 'rice noodles', ja: '米麺' }, category: 'pantry' },
      { id: 'laksa-paste', qty: 100, unit: 'g', name: { en: 'vegetarian laksa paste', ja: 'ベジタリアン・ラクサペースト' }, category: 'pantry' },
      { id: 'coconut-milk', qty: 400, unit: 'ml', name: { en: 'light coconut milk', ja: 'ライトココナッツミルク' }, category: 'pantry' },
      { id: 'bean-sprout', qty: 200, unit: 'g', name: { en: 'bean sprouts', ja: 'もやし' }, category: 'produce' },
      { id: 'bok-choy', qty: 300, unit: 'g', name: { en: 'bok choy', ja: '青梗菜' }, category: 'produce' },
      { id: 'lime', qty: 1, unit: 'pc', name: { en: 'lime', ja: 'ライム' }, category: 'produce' }
    ],
    steps: [
      { en: 'Prepare noodles according to packet directions; drain.', ja: '米麺を表示どおりに戻し、水を切る。' },
      { en: 'Fry laksa paste for 2 minutes, then add coconut milk and 500 ml water.', ja: 'ラクサペーストを2分炒め、ココナッツミルクと水500mlを加える。' },
      { en: 'Add cubed tofu and bok choy; simmer 6 minutes.', ja: '角切り豆腐と青梗菜を加え、6分煮る。' },
      { en: 'Add sprouts for the last minute. Serve over noodles with lime.', ja: '最後の1分にもやしを加え、麺にかけてライムを添える。' }
    ],
    safety: { en: 'Bring broth to a full simmer. Refrigerate broth and noodles separately up to 3 days.', ja: 'スープはしっかり沸騰させる。スープと麺を別々に冷蔵し3日以内。' }
  },
  {
    id: 'oyakodon', emoji: '🥚', color: 'egg', servings: 4, prepMinutes: 15, cookMinutes: 20,
    title: { en: 'Comforting Oyakodon', ja: 'ほっとする親子丼' },
    summary: { en: 'Chicken, onion and softly set egg over hot rice.', ja: '鶏肉、玉ねぎ、ふんわり卵を温かいご飯に。' },
    tags: ['family', 'quick'], allergens: ['egg', 'soy', 'gluten'],
    ingredients: [
      { id: 'chicken-thigh', qty: 500, unit: 'g', name: { en: 'boneless chicken thighs', ja: '鶏もも肉' }, category: 'protein' },
      { id: 'egg', qty: 6, unit: 'pc', name: { en: 'eggs', ja: '卵' }, category: 'protein' },
      { id: 'onion', qty: 2, unit: 'pc', name: { en: 'onions', ja: '玉ねぎ' }, category: 'produce' },
      { id: 'rice', qty: 2, unit: 'cup', name: { en: 'Japanese rice', ja: '日本米' }, category: 'pantry' },
      { id: 'dashi', qty: 350, unit: 'ml', name: { en: 'dashi stock', ja: 'だし汁' }, category: 'pantry' },
      { id: 'light-soy', qty: 3, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'mirin', qty: 2, unit: 'tbsp', name: { en: 'mirin', ja: 'みりん' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Cook rice. Slice chicken and onion into bite-size pieces.', ja: 'ご飯を炊く。鶏肉と玉ねぎを食べやすく切る。' },
      { en: 'Simmer dashi, soy and mirin with onion for 5 minutes.', ja: 'だし、醤油、みりんと玉ねぎを5分煮る。' },
      { en: 'Add chicken and simmer covered until it reaches 75°C.', ja: '鶏肉を加え、蓋をして中心75℃まで煮る。' },
      { en: 'Pour over beaten egg; cover until fully set for meal prep. Spoon over rice.', ja: '溶き卵を回し入れ、作り置き用は完全に固まるまで蓋をする。ご飯にのせる。' }
    ],
    safety: { en: 'For packed meals, cook eggs until fully set and chicken to 75°C.', ja: '弁当・作り置きでは卵を完全に固め、鶏肉は中心75℃まで加熱。' }
  },
  {
    id: 'tempeh-rendang', emoji: '🌶️', color: 'chilli', servings: 4, prepMinutes: 20, cookMinutes: 35,
    title: { en: 'Tempeh Vegetable Rendang', ja: 'テンペと野菜のルンダン' },
    summary: { en: 'Rich, aromatic plant-based rendang for batch cooking.', ja: '香り豊かで濃厚な植物性ルンダン。作り置きにも。' },
    tags: ['vegan', 'freezer', 'batch'], allergens: ['soy'],
    ingredients: [
      { id: 'tempeh', qty: 400, unit: 'g', name: { en: 'tempeh', ja: 'テンペ' }, category: 'protein' },
      { id: 'potato', qty: 500, unit: 'g', name: { en: 'potatoes', ja: 'じゃがいも' }, category: 'produce' },
      { id: 'green-bean', qty: 250, unit: 'g', name: { en: 'green beans', ja: 'いんげん' }, category: 'produce' },
      { id: 'rendang-paste', qty: 100, unit: 'g', name: { en: 'vegan rendang paste', ja: 'ヴィーガン・ルンダンペースト' }, category: 'pantry' },
      { id: 'coconut-milk', qty: 400, unit: 'ml', name: { en: 'coconut milk', ja: 'ココナッツミルク' }, category: 'pantry' },
      { id: 'lime-leaf', qty: 4, unit: 'pc', name: { en: 'makrut lime leaves', ja: 'こぶみかんの葉' }, category: 'produce' }
    ],
    steps: [
      { en: 'Cube tempeh and potatoes. Brown tempeh in a wide pot.', ja: 'テンペとじゃがいもを角切りにし、鍋でテンペを焼きつける。' },
      { en: 'Add paste and cook 2 minutes until fragrant.', ja: 'ペーストを加え、香りが立つまで2分炒める。' },
      { en: 'Add coconut milk, lime leaves and potatoes; simmer 25 minutes.', ja: 'ココナッツミルク、こぶみかんの葉、じゃがいもを加え25分煮る。' },
      { en: 'Add beans and cook 6 minutes until tender and sauce is thick.', ja: 'いんげんを加えて6分、柔らかくなりソースが濃くなるまで煮る。' }
    ],
    safety: { en: 'Check curry paste for shrimp/fish allergens. Cool shallow portions promptly.', ja: 'ペーストにえび・魚由来原料がないか確認。浅い容器で素早く冷ます。' }
  },
  {
    id: 'ginger-pork', emoji: '🐖', color: 'coral', servings: 4, prepMinutes: 15, cookMinutes: 15,
    title: { en: 'Ginger Pork & Cabbage', ja: '豚の生姜焼きとキャベツ' },
    summary: { en: 'Fast shogayaki-style pork with sweet cabbage.', ja: '手早く作れる生姜焼き風の豚肉と甘いキャベツ。' },
    tags: ['quick', 'lunchbox'], allergens: ['soy', 'gluten'],
    ingredients: [
      { id: 'pork-slice', qty: 500, unit: 'g', name: { en: 'thin-sliced pork', ja: '豚薄切り肉' }, category: 'protein' },
      { id: 'cabbage', qty: 500, unit: 'g', name: { en: 'cabbage', ja: 'キャベツ' }, category: 'produce' },
      { id: 'ginger', qty: 30, unit: 'g', name: { en: 'grated ginger', ja: 'おろし生姜' }, category: 'produce' },
      { id: 'light-soy', qty: 2, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'mirin', qty: 2, unit: 'tbsp', name: { en: 'mirin', ja: 'みりん' }, category: 'pantry' },
      { id: 'rice', qty: 2, unit: 'cup', name: { en: 'Japanese rice', ja: '日本米' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Cook rice. Mix ginger, soy and mirin.', ja: 'ご飯を炊く。生姜、醤油、みりんを混ぜる。' },
      { en: 'Stir-fry cabbage for 4 minutes; remove to a plate.', ja: 'キャベツを4分炒め、皿に取り出す。' },
      { en: 'Cook pork in one layer until no pink remains.', ja: '豚肉を広げ、赤みがなくなるまで焼く。' },
      { en: 'Add sauce, bubble for 1 minute, and serve with cabbage and rice.', ja: 'たれを加えて1分煮立て、キャベツとご飯に添える。' }
    ],
    safety: { en: 'Cook pork to 71°C. Reheat leftovers until steaming throughout.', ja: '豚肉は中心71℃まで加熱。残りは全体が熱々になるまで再加熱。' }
  },
  {
    id: 'chickpea-curry', emoji: '🍛', color: 'turmeric', servings: 6, prepMinutes: 15, cookMinutes: 30,
    title: { en: 'Chickpea Spinach Curry', ja: 'ひよこ豆とほうれん草のカレー' },
    summary: { en: 'Pantry-friendly tomato curry that freezes beautifully.', ja: '常備食材で作れて冷凍にも向くトマトカレー。' },
    tags: ['vegan', 'freezer', 'batch'], allergens: [],
    ingredients: [
      { id: 'chickpea', qty: 800, unit: 'g', name: { en: 'canned chickpeas, drained', ja: 'ひよこ豆缶（水切り）' }, category: 'pantry' },
      { id: 'canned-tomato', qty: 800, unit: 'g', name: { en: 'canned tomatoes', ja: 'トマト缶' }, category: 'pantry' },
      { id: 'spinach', qty: 300, unit: 'g', name: { en: 'spinach', ja: 'ほうれん草' }, category: 'produce' },
      { id: 'onion', qty: 2, unit: 'pc', name: { en: 'onions', ja: '玉ねぎ' }, category: 'produce' },
      { id: 'curry-powder', qty: 2, unit: 'tbsp', name: { en: 'mild curry powder', ja: '甘口カレー粉' }, category: 'pantry' },
      { id: 'coconut-milk', qty: 400, unit: 'ml', name: { en: 'light coconut milk', ja: 'ライトココナッツミルク' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Cook chopped onion with a pinch of salt for 8 minutes.', ja: '刻んだ玉ねぎを塩少々で8分炒める。' },
      { en: 'Stir in curry powder for 30 seconds.', ja: 'カレー粉を加えて30秒炒める。' },
      { en: 'Add tomatoes, chickpeas and coconut milk; simmer 18 minutes.', ja: 'トマト、ひよこ豆、ココナッツミルクを加え18分煮る。' },
      { en: 'Fold in spinach until wilted. Season and portion.', ja: 'ほうれん草を加え、しんなりしたら味を調えて小分けする。' }
    ],
    safety: { en: 'Once opened, transfer canned food to a clean container. Refrigerate up to 3 days.', ja: '缶を開けたら清潔な容器へ移す。冷蔵3日以内。' }
  },
  {
    id: 'soba-chicken-salad', emoji: '🥢', color: 'leaf', servings: 4, prepMinutes: 20, cookMinutes: 15,
    title: { en: 'Sesame Chicken Soba Salad', ja: '蒸し鶏のごま蕎麦サラダ' },
    summary: { en: 'Chilled noodles, crunchy vegetables and poached chicken.', ja: '冷たい麺、シャキシャキ野菜、しっとり蒸し鶏。' },
    tags: ['lunchbox', 'make-ahead'], allergens: ['gluten', 'soy', 'sesame'],
    ingredients: [
      { id: 'chicken-breast', qty: 500, unit: 'g', name: { en: 'chicken breast', ja: '鶏むね肉' }, category: 'protein' },
      { id: 'soba', qty: 300, unit: 'g', name: { en: 'soba noodles', ja: '蕎麦' }, category: 'pantry' },
      { id: 'carrot', qty: 2, unit: 'pc', name: { en: 'carrots', ja: 'にんじん' }, category: 'produce' },
      { id: 'cucumber', qty: 1, unit: 'pc', name: { en: 'cucumber', ja: 'きゅうり' }, category: 'produce' },
      { id: 'light-soy', qty: 2, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'rice-vinegar', qty: 2, unit: 'tbsp', name: { en: 'rice vinegar', ja: '米酢' }, category: 'pantry' },
      { id: 'sesame-oil', qty: 3, unit: 'tsp', name: { en: 'sesame oil', ja: 'ごま油' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Gently poach chicken until its centre reaches 75°C; cool and shred.', ja: '鶏肉を静かに茹で、中心75℃に達したら冷まして裂く。' },
      { en: 'Cook soba, rinse thoroughly under cold water and drain.', ja: '蕎麦を茹で、冷水でよく洗って水を切る。' },
      { en: 'Whisk soy, vinegar and sesame oil.', ja: '醤油、酢、ごま油を混ぜる。' },
      { en: 'Toss noodles with julienned vegetables, chicken and dressing.', ja: '麺、千切り野菜、鶏肉、たれを和える。' }
    ],
    safety: { en: 'Keep chilled below 5°C; do not leave packed salad at room temperature over 2 hours.', ja: '5℃以下で保冷し、常温で2時間以上置かない。' }
  },
  {
    id: 'beef-pepper', emoji: '🫑', color: 'leaf', servings: 4, prepMinutes: 20, cookMinutes: 12,
    title: { en: 'Black Pepper Beef & Broccoli', ja: '牛肉とブロッコリーの黒胡椒炒め' },
    summary: { en: 'A speedy hawker-inspired stir-fry with plenty of vegetables.', ja: '野菜たっぷり、ホーカー風の手早い炒め物。' },
    tags: ['quick', 'high-protein'], allergens: ['soy', 'gluten'],
    ingredients: [
      { id: 'beef-slice', qty: 500, unit: 'g', name: { en: 'lean sliced beef', ja: '牛赤身薄切り' }, category: 'protein' },
      { id: 'broccoli', qty: 500, unit: 'g', name: { en: 'broccoli', ja: 'ブロッコリー' }, category: 'produce' },
      { id: 'capsicum', qty: 2, unit: 'pc', name: { en: 'capsicums', ja: 'パプリカ' }, category: 'produce' },
      { id: 'oyster-sauce', qty: 2, unit: 'tbsp', name: { en: 'oyster sauce', ja: 'オイスターソース' }, category: 'pantry' },
      { id: 'light-soy', qty: 1, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'black-pepper', qty: 2, unit: 'tsp', name: { en: 'coarsely ground black pepper', ja: '粗挽き黒胡椒' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Mix oyster sauce, soy, pepper and 3 tablespoons water.', ja: 'オイスターソース、醤油、胡椒、水大さじ3を混ぜる。' },
      { en: 'Blanch broccoli for 2 minutes; drain.', ja: 'ブロッコリーを2分下茹でし、水を切る。' },
      { en: 'Sear beef in two batches; remove when just cooked.', ja: '牛肉を2回に分けて焼き、火が通ったら取り出す。' },
      { en: 'Stir-fry capsicum, return beef and broccoli, add sauce and toss 1 minute.', ja: 'パプリカを炒め、牛肉とブロッコリーを戻し、たれを加えて1分炒め合わせる。' }
    ],
    safety: { en: 'Use a clean plate for cooked beef; do not reuse the raw-meat plate.', ja: '加熱後の牛肉には清潔な皿を使い、生肉を置いた皿を再利用しない。' }
  },
  {
    id: 'tuna-onigiri', emoji: '🍙', color: 'sky', servings: 4, prepMinutes: 20, cookMinutes: 25,
    title: { en: 'Tuna Corn Onigiri Box', ja: 'ツナコーンおにぎり弁当' },
    summary: { en: 'Easy filled rice balls with edamame and fruit.', ja: '作りやすい具入りおにぎり。枝豆と果物を添えて。' },
    tags: ['lunchbox', 'kid-friendly'], allergens: ['fish', 'egg', 'soy'],
    ingredients: [
      { id: 'rice', qty: 2, unit: 'cup', name: { en: 'Japanese rice', ja: '日本米' }, category: 'pantry' },
      { id: 'canned-tuna', qty: 180, unit: 'g', name: { en: 'canned tuna, drained', ja: 'ツナ缶（水切り）' }, category: 'protein' },
      { id: 'corn', qty: 150, unit: 'g', name: { en: 'sweetcorn', ja: 'コーン' }, category: 'produce' },
      { id: 'mayonnaise', qty: 2, unit: 'tbsp', name: { en: 'mayonnaise', ja: 'マヨネーズ' }, category: 'pantry' },
      { id: 'nori', qty: 4, unit: 'sheet', name: { en: 'nori sheets', ja: '焼き海苔' }, category: 'pantry' },
      { id: 'edamame', qty: 300, unit: 'g', name: { en: 'frozen shelled edamame', ja: '冷凍むき枝豆' }, category: 'frozen' }
    ],
    steps: [
      { en: 'Cook rice and cool only until safe to handle; keep it covered.', ja: 'ご飯を炊き、触れる温度までだけ冷ます。乾かないよう覆う。' },
      { en: 'Mix tuna, corn and mayonnaise.', ja: 'ツナ、コーン、マヨネーズを混ぜる。' },
      { en: 'With clean wet hands, shape eight rice balls around the filling; wrap with nori.', ja: '清潔な濡れた手で具を包み、8個のおにぎりを作って海苔を巻く。' },
      { en: 'Boil edamame thoroughly, cool and pack separately.', ja: '枝豆を十分に茹で、冷まして別に詰める。' }
    ],
    safety: { en: 'Use freshly cooked rice, clean hands and rapid cooling. Keep chilled; eat within 24 hours.', ja: '炊きたてご飯と清潔な手で作り、素早く冷ます。冷蔵し24時間以内に食べる。' }
  },
  {
    id: 'lentil-soup', emoji: '🥣', color: 'tomato', servings: 6, prepMinutes: 15, cookMinutes: 40,
    title: { en: 'Red Lentil Tomato Soup', ja: '赤レンズ豆のトマトスープ' },
    summary: { en: 'A soothing, freezer-ready soup with hidden vegetables.', ja: '野菜をおいしく摂れる、冷凍向きのやさしいスープ。' },
    tags: ['vegan', 'freezer', 'batch'], allergens: [],
    ingredients: [
      { id: 'red-lentil', qty: 300, unit: 'g', name: { en: 'red lentils', ja: '赤レンズ豆' }, category: 'pantry' },
      { id: 'canned-tomato', qty: 800, unit: 'g', name: { en: 'canned tomatoes', ja: 'トマト缶' }, category: 'pantry' },
      { id: 'carrot', qty: 3, unit: 'pc', name: { en: 'carrots', ja: 'にんじん' }, category: 'produce' },
      { id: 'celery', qty: 3, unit: 'stalk', name: { en: 'celery stalks', ja: 'セロリ' }, category: 'produce' },
      { id: 'onion', qty: 1, unit: 'pc', name: { en: 'onion', ja: '玉ねぎ' }, category: 'produce' },
      { id: 'veg-stock', qty: 1.2, unit: 'L', name: { en: 'low-sodium vegetable stock', ja: '減塩野菜スープ' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Rinse lentils. Dice onion, carrot and celery.', ja: 'レンズ豆を洗い、玉ねぎ、にんじん、セロリを角切りにする。' },
      { en: 'Cook vegetables in a little oil for 8 minutes.', ja: '野菜を少量の油で8分炒める。' },
      { en: 'Add lentils, tomatoes and stock; simmer 28 minutes.', ja: 'レンズ豆、トマト、スープを加え28分煮る。' },
      { en: 'Blend partly for texture, then season.', ja: '一部をブレンダーにかけてとろみをつけ、味を調える。' }
    ],
    safety: { en: 'Vent hot soup when blending. Divide into shallow containers before chilling.', ja: '熱いスープを撹拌する際は蒸気を逃す。浅い容器に分けて冷やす。' }
  },
  {
    id: 'teriyaki-tofu', emoji: '🥦', color: 'leaf', servings: 4, prepMinutes: 20, cookMinutes: 20,
    title: { en: 'Crispy Teriyaki Tofu Bowls', ja: 'カリカリ照り焼き豆腐丼' },
    summary: { en: 'Crisp tofu, broccoli and carrots in a glossy sauce.', ja: 'カリッとした豆腐、ブロッコリー、にんじんを照りだれで。' },
    tags: ['vegetarian', 'lunchbox'], allergens: ['soy', 'gluten', 'sesame'],
    ingredients: [
      { id: 'firm-tofu', qty: 600, unit: 'g', name: { en: 'firm tofu', ja: '木綿豆腐' }, category: 'protein' },
      { id: 'broccoli', qty: 400, unit: 'g', name: { en: 'broccoli', ja: 'ブロッコリー' }, category: 'produce' },
      { id: 'carrot', qty: 2, unit: 'pc', name: { en: 'carrots', ja: 'にんじん' }, category: 'produce' },
      { id: 'rice', qty: 2, unit: 'cup', name: { en: 'brown rice', ja: '玄米' }, category: 'pantry' },
      { id: 'light-soy', qty: 3, unit: 'tbsp', name: { en: 'soy sauce', ja: '醤油' }, category: 'pantry' },
      { id: 'mirin', qty: 2, unit: 'tbsp', name: { en: 'mirin', ja: 'みりん' }, category: 'pantry' },
      { id: 'sesame-seed', qty: 1, unit: 'tbsp', name: { en: 'sesame seeds', ja: '白ごま' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Cook rice. Press tofu for 10 minutes and cube.', ja: 'ご飯を炊く。豆腐を10分水切りして角切りにする。' },
      { en: 'Pan-fry tofu until golden on all sides.', ja: '豆腐の全面がきつね色になるまで焼く。' },
      { en: 'Steam broccoli and carrots until just tender.', ja: 'ブロッコリーとにんじんを歯ごたえが残る程度に蒸す。' },
      { en: 'Bubble soy and mirin for 1 minute, coat tofu, then assemble bowls and add sesame.', ja: '醤油とみりんを1分煮立て豆腐に絡め、丼に盛ってごまを振る。' }
    ],
    safety: { en: 'Refrigerate opened tofu immediately. Use within the pack directions and reheat thoroughly.', ja: '開封した豆腐はすぐ冷蔵。表示期限内に使い、十分に再加熱する。' }
  },
  {
    id: 'fish-curry', emoji: '🐠', color: 'turmeric', servings: 4, prepMinutes: 20, cookMinutes: 25,
    title: { en: 'Tamarind Fish Curry', ja: '白身魚のタマリンドカレー' },
    summary: { en: 'Tangy Singapore-style curry with okra and tomatoes.', ja: 'オクラとトマト入り、酸味のあるシンガポール風カレー。' },
    tags: ['one-pot', 'dinner'], allergens: ['fish'],
    ingredients: [
      { id: 'white-fish', qty: 600, unit: 'g', name: { en: 'firm white fish', ja: '白身魚' }, category: 'protein' },
      { id: 'okra', qty: 250, unit: 'g', name: { en: 'okra', ja: 'オクラ' }, category: 'produce' },
      { id: 'tomato', qty: 3, unit: 'pc', name: { en: 'tomatoes', ja: 'トマト' }, category: 'produce' },
      { id: 'fish-curry-powder', qty: 2, unit: 'tbsp', name: { en: 'fish curry powder', ja: 'フィッシュカレー粉' }, category: 'pantry' },
      { id: 'tamarind', qty: 2, unit: 'tbsp', name: { en: 'tamarind paste', ja: 'タマリンドペースト' }, category: 'pantry' },
      { id: 'coconut-milk', qty: 200, unit: 'ml', name: { en: 'coconut milk', ja: 'ココナッツミルク' }, category: 'pantry' }
    ],
    steps: [
      { en: 'Cut fish into large pieces and pat dry.', ja: '魚を大きめに切り、水分を拭く。' },
      { en: 'Toast curry powder briefly, then add 400 ml water, tamarind and coconut milk.', ja: 'カレー粉を短く炒め、水400ml、タマリンド、ココナッツミルクを加える。' },
      { en: 'Add tomatoes and okra; simmer 8 minutes.', ja: 'トマトとオクラを加え8分煮る。' },
      { en: 'Add fish and gently simmer 6–8 minutes until it reaches 63°C.', ja: '魚を加え、中心63℃になるまで6〜8分静かに煮る。' }
    ],
    safety: { en: 'Buy fish last and keep cold. Discard any fish with a strong ammonia smell.', ja: '魚は買い物の最後に購入し保冷。強いアンモニア臭がある魚は使用しない。' }
  },
  {
    id: 'breakfast-frittata', emoji: '🍳', color: 'egg', servings: 6, prepMinutes: 15, cookMinutes: 25,
    title: { en: 'Vegetable Breakfast Frittata', ja: '野菜たっぷり朝食フリッタータ' },
    summary: { en: 'Sliceable egg bake for quick breakfasts and lunchboxes.', ja: '朝食や弁当に切り分けやすい、野菜入り卵焼き。' },
    tags: ['breakfast', 'make-ahead', 'low-carb'], allergens: ['egg', 'dairy'],
    ingredients: [
      { id: 'egg', qty: 10, unit: 'pc', name: { en: 'eggs', ja: '卵' }, category: 'protein' },
      { id: 'milk', qty: 120, unit: 'ml', name: { en: 'milk', ja: '牛乳' }, category: 'dairy' },
      { id: 'spinach', qty: 200, unit: 'g', name: { en: 'spinach', ja: 'ほうれん草' }, category: 'produce' },
      { id: 'capsicum', qty: 1, unit: 'pc', name: { en: 'red capsicum', ja: '赤パプリカ' }, category: 'produce' },
      { id: 'mushroom', qty: 250, unit: 'g', name: { en: 'mushrooms', ja: 'きのこ' }, category: 'produce' },
      { id: 'cheddar', qty: 100, unit: 'g', name: { en: 'grated cheddar', ja: 'シュレッドチェダー' }, category: 'dairy' }
    ],
    steps: [
      { en: 'Heat oven to 190°C and line a 20 cm baking dish.', ja: 'オーブンを190℃に予熱し、20cm型に紙を敷く。' },
      { en: 'Cook mushrooms and capsicum until their moisture evaporates; add spinach to wilt.', ja: 'きのことパプリカを水分が飛ぶまで炒め、ほうれん草を加える。' },
      { en: 'Whisk eggs and milk, fold in vegetables and half the cheese.', ja: '卵と牛乳を混ぜ、野菜とチーズ半量を加える。' },
      { en: 'Pour into dish, top with cheese and bake 20–25 minutes until fully set.', ja: '型に流し残りのチーズをのせ、完全に固まるまで20〜25分焼く。' }
    ],
    safety: { en: 'Bake until the centre reaches 71°C. Refrigerate slices up to 3 days.', ja: '中心71℃まで焼く。切り分けたものは冷蔵3日以内。' }
  }
];

export const categories = {
  produce: { en: 'Produce', ja: '野菜・果物' },
  protein: { en: 'Protein', ja: '肉・魚・豆腐' },
  pantry: { en: 'Pantry', ja: '常温食品' },
  dairy: { en: 'Dairy', ja: '乳製品' },
  frozen: { en: 'Frozen', ja: '冷凍食品' }
};
